import each from 'lodash/each';
import { UPDATE_SETTINGS_PARAMS, INITIALIZE_DATA, UPDATE_STATE_PARAMS, RESET_STATE } from './SaveFormModalConstants';

export const initialState = {
  forms: [],
  settings: {
    location: 'online',
    values: 'empty',
  },
  myFormNames: [],
  refreshForms: null,
};

// eslint-disable-next-line default-param-last
export default function searchFormModalReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SETTINGS_PARAMS: {
      const updatedSettings = { ...state.settings, ...action.params };
      return {
        ...state,
        settings: { ...updatedSettings },
      };
    }
    case UPDATE_STATE_PARAMS:
      return {
        ...state,
        ...action.params,
      };
    case INITIALIZE_DATA: {
      let newFormsNumber = 0;
      const myFormNames = [];
      each(action.payload, (form) => {
        // Extract trailing number safely without regex backtracking
        let currentNumber = 0;
        const name = form.displayName;
        let i = name.length - 1;
        while (i >= 0 && name[i] >= '0' && name[i] <= '9') {
          i -= 1;
        }
        if (i < name.length - 1) {
          currentNumber = parseInt(name.slice(i + 1), 10);
        }
        myFormNames.push(form.displayName);
        if (currentNumber > newFormsNumber) {
          newFormsNumber = currentNumber;
        }
      });
      return {
        ...state,
        forms: action.payload ? [...action.payload] : [],
        settings: { ...state.settings, name: `My Form ${newFormsNumber + 1}` },
        myFormNames,
        refreshForms: action.refreshForms ? action.refreshForms : null,
      };
    }
    case RESET_STATE:
      return {
        ...state,
        forms: [],
        settings: {
          location: 'online',
          values: 'empty',
        },
        myFormNames: [],
        refreshForms: null,
      };
    default: {
      return state;
    }
  }
}
